(() => {
  const SELECTOR = '[data-alkom-rail]';

  const closeDetails = (button) => {
    const details = button.closest('details');
    if (!details) return;
    details.removeAttribute('open');
    details.querySelector('summary')?.focus();
  };

  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const mobileNavBackground = (details) => {
    const shell = details.closest('[data-alkom-header]');
    const header = details.closest('.alkom-header');
    return [
      shell?.querySelector('.alkom-release-line'),
      header?.querySelector('.alkom-desktop-nav'),
      header?.querySelector('.alkom-wordmark'),
      header?.querySelector('.alkom-header__utilities'),
      document.querySelector('main'),
      document.querySelector('footer')
    ].filter(Boolean);
  };

  const setManagedInert = (elements, inert) => {
    elements.forEach((element) => {
      if (inert) {
        if (!element.hasAttribute('inert')) element.dataset.alkomManagedInert = 'true';
        element.inert = true;
      } else if (element.dataset.alkomManagedInert === 'true') {
        element.inert = false;
        delete element.dataset.alkomManagedInert;
      }
    });
  };

  const initMobileNav = (details) => {
    if (details.dataset.alkomNavReady === 'true') return;
    details.dataset.alkomNavReady = 'true';
    const summary = details.querySelector('summary');

    const updateState = () => {
      const isOpen = details.open;
      summary?.setAttribute('aria-expanded', String(isOpen));
      setManagedInert(mobileNavBackground(details), isOpen);
      document.documentElement.classList.toggle('alkom-nav-open', isOpen);

      if (isOpen) {
        document.querySelectorAll('.alkom-header details[open]').forEach((openDetails) => {
          if (openDetails !== details) openDetails.removeAttribute('open');
        });
        requestAnimationFrame(() => details.querySelector('[data-alkom-close-details]')?.focus());
      }
    };

    details.addEventListener('toggle', updateState);
    updateState();
  };

  const railStep = (rail) => {
    const card = rail.querySelector(':scope > *');
    if (!card) return rail.clientWidth;
    const styles = window.getComputedStyle(rail);
    return card.getBoundingClientRect().width + parseFloat(styles.columnGap || styles.gap || 0);
  };

  const updateRail = (rail) => {
    const group = rail.closest('[data-alkom-rail-group]') || rail.parentElement;
    const previous = group?.querySelector('[data-alkom-rail-prev]');
    const next = group?.querySelector('[data-alkom-rail-next]');
    const atStart = rail.scrollLeft <= 2;
    const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    if (previous) previous.disabled = atStart;
    if (next) next.disabled = atEnd;
  };

  const initRail = (rail) => {
    if (rail.dataset.alkomReady === 'true') return;
    rail.dataset.alkomReady = 'true';
    const group = rail.closest('[data-alkom-rail-group]') || rail.parentElement;
    group?.querySelector('[data-alkom-rail-prev]')?.addEventListener('click', () => {
      rail.scrollBy({ left: -railStep(rail), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    group?.querySelector('[data-alkom-rail-next]')?.addEventListener('click', () => {
      rail.scrollBy({ left: railStep(rail), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    rail.addEventListener('scroll', () => updateRail(rail), { passive: true });
    new ResizeObserver(() => updateRail(rail)).observe(rail);
    updateRail(rail);
  };

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initRail);
    root.querySelectorAll('.alkom-mobile-nav').forEach(initMobileNav);
    root.querySelectorAll('[data-alkom-close-details]').forEach((button) => {
      if (button.dataset.alkomReady === 'true') return;
      button.dataset.alkomReady = 'true';
      button.addEventListener('click', () => closeDetails(button));
    });
  };

  document.addEventListener('keydown', (event) => {
    const openNav = document.querySelector('.alkom-mobile-nav[open]');

    if (event.key === 'Tab' && openNav) {
      const panel = openNav.querySelector('.alkom-mobile-nav__panel');
      const focusable = [...(panel?.querySelectorAll(FOCUSABLE_SELECTOR) || [])].filter((element) => element.offsetParent !== null);
      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
      return;
    }

    if (event.key === 'Escape') {
      const openDetails = document.querySelector('.alkom-header details[open]');
      if (!openDetails) return;
      openDetails.removeAttribute('open');
      openDetails.querySelector('summary')?.focus();
    }
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.alkom-header-search[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }
})();
